"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.filterProps = void 0;
const consoleColors = ['color: #d96666', 'color: #6495ed'];
const baseFilter = ['appName', 'service', 'message'];
const serverFilter = [];
const consoleFilter = [
    'printOriginalToConsole',
    'isConsoleOnly',
    'filename',
    'function',
];
const filterProps = (isConsoleLog, obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if ((isConsoleLog ? consoleFilter : serverFilter).includes(key) ||
            baseFilter.includes(key)) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
};
exports.filterProps = filterProps;
const formatErrorForServer = (data) => {
    const { error, err, er, e } = data;
    const checkError = error || err || er || e;
    const errorFieldName = error ? 'error' : err ? 'err' : er ? 'er' : 'e';
    if (checkError && checkError instanceof Error) {
        const { name, message, stack } = checkError;
        data[errorFieldName] = {
            name,
            message,
            stack,
        };
    }
};
const formatServerLog = ({ module = '', message, logData, }) => {
    const newLogData = (0, exports.filterProps)(false, logData);
    formatErrorForServer(newLogData);
    return [
        `[Client]${module.replace(/%c| /g, '')}${(message && ` ${message}`) || ''}`,
        newLogData,
    ];
};
const formatConsoleLog = ({ message, logMessage, logData }, consoleColors) => {
    const newLogData = (0, exports.filterProps)(true, logData);
    return [
        logMessage,
        ...consoleColors,
        message + (Object.keys(newLogData).length ? ',' : ''),
        ...Object.entries(newLogData).reduce((acc, [key, value]) => {
            acc.push(`${key}:`, typeof value === 'string' ? `${value},` : value);
            return acc;
        }, []),
    ];
};
const format = (log) => {
    var _a;
    const message = (_a = log.message) !== null && _a !== void 0 ? _a : '';
    const module = `%c[${log.appName}]${(log.service && ` [${log.service}]`) || ''}`;
    const callerName = ` %c[${log.filename}] [${log.function}]`;
    const logMessage = `${module}${callerName}`;
    const formattedMessage = {
        module,
        logMessage,
        message,
        logData: log,
    };
    return {
        server: (!log.isConsoleOnly && formatServerLog(formattedMessage)) || undefined,
        console: formatConsoleLog(formattedMessage, consoleColors),
    };
};
exports.format = format;
